if (!customElements.get('kimaia-shipping-estimate')) customElements.define('kimaia-shipping-estimate', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    this.labels = JSON.parse(this.querySelector('[data-kse-labels]').textContent);
    this.country = this.querySelector('[data-kse-country]');
    this.country.value = ['NL','BE'].includes(this.dataset.country) ? this.dataset.country : 'other';
    this.zip = this.querySelector('[data-kse-zip]');
    this.country.addEventListener('change', () => { this.reset(); this.render(); });
    this.zip.addEventListener('input', () => { this.reset(); this.render(); });
    this.querySelector('[data-kse-calculate]').addEventListener('click', () => this.calculate());
    if (this.cart) this.render();
  }
  reset() { this.sequence = (this.sequence || 0) + 1; this.rate = null; this.querySelector('[data-kse-status]').textContent = ''; this.querySelector('[data-kse-calculate]').disabled = false; }
  setCart(cart) {
    this.cart = cart;
    if (!this.ready) return;
    const key = JSON.stringify([cart.total_price,cart.items.map(i=>[i.key,i.quantity,i.final_line_price]) ,cart.discount_codes]);
    if (key !== this.cartKey) { this.cartKey = key; this.reset(); }
    this.render();
  }
  money(cents) { return new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.cart.currency}).format(cents/100); }
  render() {
    const c=this.cart;if(!c)return;this.hidden=!c.items.length;
    const domestic=['NL','BE'].includes(this.country.value)&&c.currency==='EUR';
    const allSub=c.items.length&&c.items.every(i=>i.selling_plan_allocation);
    const mixed=c.items.some(i=>i.selling_plan_allocation)&&!allSub;
    let rate=this.rate;
    if(rate==null&&domestic&&!mixed)rate=!c.requires_shipping||allSub||c.total_price>=5000?0:595;
    this.querySelector('[data-kse-shipping]').textContent=rate==null?this.labels.checkout:(rate?this.money(rate):this.labels.free);
    this.querySelector('[data-kse-total-row]').hidden=rate==null;
    this.querySelector('[data-kse-total]').textContent=rate==null?'':this.money(c.total_price+rate);
    this.querySelector('[data-kse-note]').textContent=domestic?(mixed&&this.rate==null?this.labels.mixed:this.labels.terms):this.labels.checkout;
    this.querySelector('[data-kse-exact]').hidden=!domestic;
    if(mixed&&domestic&&this.rate==null)this.querySelector('[data-kse-exact]').open=true;
  }
  async calculate() {
    if(!this.cart||!['NL','BE'].includes(this.country.value))return;
    const zip=this.zip.value.trim(),status=this.querySelector('[data-kse-status]');
    if(!(this.country.value==='NL'?/^[1-9][0-9]{3}\s?[a-z]{2}$/i:/^[1-9][0-9]{3}$/).test(zip)){status.textContent=this.labels.postcode;this.zip.focus();return;}
    const sequence=++this.sequence,key=this.cartKey,button=this.querySelector('[data-kse-calculate]');button.disabled=true;status.textContent=this.labels.loading;
    const query=new URLSearchParams({'shipping_address[country]':this.country.value==='NL'?'Netherlands':'Belgium','shipping_address[zip]':zip});
    const base=(window.Shopify?.routes?.root||'/')+'cart/';
    try {
      let response=await fetch(base+'prepare_shipping_rates.json?'+query,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error();
      let result=null;
      for(let i=0;i<8;i++){
        if(sequence!==this.sequence||key!==this.cartKey)return;
        response=await fetch(base+'async_shipping_rates.json?'+query,{credentials:'same-origin',headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error();result=await response.json();
        if(result?.shipping_rates)break;
        await new Promise(resolve=>setTimeout(resolve,700));
      }
      if(sequence!==this.sequence||key!==this.cartKey)return;
      const rates=result?.shipping_rates?.map(r=>Math.round(Number(r.price)*100)).filter(Number.isFinite);
      if(!rates?.length)throw new Error();
      this.rate=Math.min(...rates);this.render();status.textContent=this.labels.confirmed;
    }catch{if(sequence===this.sequence)status.textContent=this.labels.error;}
    finally{if(sequence===this.sequence)button.disabled=false;}
  }
});
